// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__NQP+T","title":"NotFound_title__yG3ZV","description":"NotFound_description__kFN1+","backButton":"NotFound_backButton__nedKN"};